<!--货场黑名单列表-->
<template>
  <el-button-group>
    <el-button v-if="this.$fun.isQx(this.qx, 'yardblacklist:add')" type="primary" icon="Plus" @click="addInfo">添加</el-button>
    <el-button v-if="this.$fun.isQx(this.qx, 'yardblacklist:del')" type="danger" icon="Delete" @click="delInfo">删除</el-button>
    <el-button v-if="this.$fun.isQx(this.qx, 'yardblacklist:enable')" type="success" icon="CircleCheck" @click="enableInfo(true)">启用</el-button>
    <el-button v-if="this.$fun.isQx(this.qx, 'yardblacklist:enable')" type="info" icon="CircleClose" @click="enableInfo(false)">禁用</el-button>
  </el-button-group>
  <!-- <div class="fun">
    <div class="search-div">
      <el-input placeholder="请输入关键字" prefix-icon="el-icon-search" v-model="searchKey" clearable class="width"></el-input>
      <el-button type="primary" icon="search" @click="getData">查询</el-button>
    </div>
  </div> -->
  <el-table v-loading="tableLoading" :data="tableData" highlight-current-row stripe border
      :height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange"
      header-row-class-name="header-row" header-cell-class-name="header-cell">
    <el-table-column type="selection" width="40"></el-table-column>
    <el-table-column prop="yardName" label="货场名称" show-overflow-tooltip>
      <template #default="scope">
        {{scope.row.yardName}}
      </template>
    </el-table-column>
    <el-table-column prop="cause" label="原因" show-overflow-tooltip></el-table-column>
    <el-table-column prop="queue" label="排序" width="60">
      <template #default="scope">
        <el-icon class="icon-cursor" @click="queueInfo(scope.row.id, false)"><SortDown /></el-icon>
        <el-icon class="icon-cursor" :title=scope.row.queue @click="queueInfo(scope.row.id, true)"><SortUp /></el-icon>
      </template>
    </el-table-column>
    <el-table-column label="状态" width="60">
      <template #default="scope">
        <el-icon v-if="scope.row.isEnable" class="check" title="启用"><Check /></el-icon>
        <el-icon v-else class="close" title="禁用"><Close /></el-icon>
      </template>
    </el-table-column>
    <el-table-column prop="inputter" label="录入人" width="100"></el-table-column>
    <el-table-column prop="upTime" label="录入时间" sortable width="150"></el-table-column>
  </el-table>
  <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
   :current-page="currentPage" :page-sizes="[10, 15, 20, 30, 40]"
   :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total='tableTotal'>
  </el-pagination>
  <el-dialog :title="dialogTitle" v-model="dialogFormVisible" :close-on-click-modal="false" :before-close="closeForm" append-to-body="true" width="60%">
    <el-form ref="formRef" :model="form" :rules="rules" label-width="130px">
      <el-input v-model="form.id" type="hidden" class="none"></el-input>
      <el-form-item label="货场名称" prop="yardGrade">
        <el-select v-model="form.yardId" filterable clearable placeholder="请选择货场名称">
          <el-option
            v-for="item in yardList" :key="item.key" :label="item.value" :value="item.key">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="原因" prop="cause" >
        <el-input v-model="form.cause" type="textarea" rows=5 maxlength="200" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="排序(降序)">
        <el-input-number v-model="form.queue" :min="0" />
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="closeForm">关 闭</el-button>
        <el-button @click="resetForm">重 填</el-button>
        <el-button type="primary" @click="saveInfo">确 定</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'yardblacklist',
  data () {
    return {
      qx: '',
      tableLoading: false,
      currentPage: 1,
      pagesize: 15,
      tableTotal: 0,
      tableData: [],
      selectionIds: '',
      dialogFormVisible: false,
      dialogTitle: '',
      form: {
        id: '',
        yardId: '',
        cause: '',
        queue: 0
      },
      rules: {
        // name: [
        //   { required: true, message: '请输入货场名称', trigger: 'blur' },
        //   { min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur' }
        // ],
        yardId: [
          { required: true, message: '请选择货场名称', trigger: 'blur' }
        ]
      },
      // 是否可点击
      disabled: false,
      searchKey: '',
      yardList: []
    }
  },
  // 接收父组件传值
  props: ['clientHeight'],
  mounted () {
    this.qx = this.$route.params.qx
    // const ui = this.$api.ui
    // if (ui == null) {
    //   this.$router.push({ path: '/login' })
    // }
    this.getTableHeight()
    // this.$route.params.sid this.$route.query.sid
    this.getData()
    this.getYardData()
  },
  methods: {
    // pageSize 新每页条数改变时触发(每页下拉显示数据)
    handleSizeChange (size) {
      this.pagesize = size
      this.getData()
    },
    // 新当前页改变时触发(点击第几页)
    handleCurrentChange (currentPage) {
      this.currentPage = currentPage
      this.getData()
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
      this.selectionIds = ''
      for (var i = 0; i < val.length; i++) {
        if (this.selectionIds === '') {
          this.selectionIds = val[i].id
        } else {
          this.selectionIds += ',' + val[i].id
        }
      }
    },
    async getData () {
      this.tableLoading = true
      const params = '?key=' + this.searchKey + '&pagesize=' + this.pagesize + '&pageindex=' + this.currentPage
      const { data: ret } = await this.$http.get(this.$api.yardblacklistlist + params)
      if (ret.status === 0) {
        this.tableData = ret.data.rows
        this.tableTotal = ret.data.total
        // console.log('tableData=', this.tableData)
      }
      this.tableLoading = false
    },
    async getYardData () {
      const { data: ret } = await this.$http.get(this.$api.yardyardlist)
      console.log('yardyardlist=', ret)
      if (ret.status === 0) {
        if (ret.data === null) {
          this.$message({
            message: ret.message,
            type: 'warning'
          })
          return
        }
        this.yardList = ret.data
      }
    },
    addInfo () {
      this.dialogTitle = '添加货场黑名单'
      this.dialogFormVisible = true
      this.form.id = ''
    },
    async editInfo (id) {
      this.dialogFormVisible = true
      const { data: ret } = await this.$http.get1(this.$api.yardid + '/' + id)
      if (ret.status === 0 && ret.data !== null) {
        const obj = ret.data
        Object.keys(this.form).forEach(key => {
          this.form[key] = obj[key]
        })
        this.dialogTitle = '修改货场黑名单'
      } else {
        this.$message.error(ret.message)
      }
    },
    saveInfo () {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          // console.log('this.form=', this.form)
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          const { data: ret } = await this.$http.post(this.$api.yardblacklistsave, this.form)
          if (ret.status === 0) {
            this.$message.success(ret.message)
            this.getData()
            this.closeForm()
          } else {
            this.$message.error(ret.message)
          }
          loading.close()
        } else {
          this.$message.error('验证没通过。')
          return false
        }
      })
    },
    delInfo () {
      if (this.selectionIds === '') {
        this.$message.error('请选择将删除的信息。')
        return
      }
      this.$confirm('此操作将删除已选择的信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        const { data: ret } = await this.$http.post(this.$api.yardblacklistdel + '?ids=' + this.selectionIds)
        if (ret.status === 0) {
          this.getData()
          this.$message.success(ret.message)
        } else {
          this.$message.error(ret.message)
        }
        loading.close()
      })
    },
    async enableInfo (bo) {
      const s = bo ? '启用' : '禁用'
      if (this.selectionIds === '') {
        this.$message.error('请选择将' + s + '的信息。')
        return
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const params = '?ids=' + this.selectionIds + '&bo=' + bo
      const { data: ret } = await this.$http.post(this.$api.yardblacklistenable + params)
      if (ret.status === 0) {
        this.getData()
        this.$message.success(ret.message)
      } else {
        this.$message.error(ret.message)
      }
      loading.close()
    },
    async queueInfo (id, bo) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const params = '?id=' + id + '&bo=' + bo
      const { data: ret } = await this.$http.post(this.$api.yardblacklistqueue + params)
      if (ret.status === 0) {
        this.getData()
        this.$message.success(ret.message)
      } else {
        this.$message.error(ret.message)
      }
      loading.close()
    },
    resetForm () {
      this.$refs.formRef.resetFields()
      this.form.queue = 0
    },
    closeForm () {
      this.resetForm()
      this.dialogFormVisible = false
    },
    getTableHeight () {
      this.tableHeight = this.clientHeight - 84 - 39
    }
  },
  watch: {
    clientHeight: function (val) {
      this.getTableHeight()
    }
  }
}
</script>

<style lang="less" scoped>
.center {
  text-align: center;
}
</style>
